import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("UserInput")
export class UserInput {
    @JsonProperty("mediaId", String, true)
    public mediaId: string = JsonPropertyEmpty;

    public constructor(args?: Partial<UserInput>) {
        Object.assign(this, args);
    }
}
